<template>
  <div id="app" class="main-app">
    <div class="columns is-gapless">
      <nav-bar></nav-bar>
    </div>

    <div class="columns is-gapless">
      <div class="column main-column">
        <section class="section app-content" v-if="userData">
          <flash-message></flash-message>
          <transition name="pageslide">
            <router-view></router-view>
          </transition>
        </section>

        <splash-screen v-else></splash-screen>
      </div>

      <left-menu></left-menu>
    </div>
  </div>
</template>


<script>
import NavBar from "@/components/NavBar.vue";
import LeftMenu from "@/components/LeftMenu.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import SplashScreen from "@/components/SplashScreen.vue";

export default {
  name: `App`,

  data() {
    return {
      series: [],
    };
  },

  components: {
    NavBar,
    LeftMenu,
    FlashMessage,
    SplashScreen,
  },

  computed: {
    userData() {
      if (
        this.$store.state.user.email !== `` &&
        this.$store.state.user.name !== ``
      ) {
        return true;
      }
      return false;
    },
  },

  methods: {
    getInitialData() {
      this.$store.dispatch(`getInitialData`);
    },
    getVideoList() {
      this.$store.dispatch(`getVideoList`);
    },
    getGvsList() {
      this.$store.dispatch(`getGvList`);
    },
  },

  created() {
    this.getInitialData();
    this.getVideoList();
    this.getGvsList();

    this.$router.beforeEach((to, from, next) => {
      if (
        this.$store.state.user.accountStatus === `לא פעיל` &&
        to.path !== `/renew`
      ) {
        next({ name: `renew` });
      } else if (
        this.$store.state.user.accountStatus === `לא פעיל` &&
        from.name === `renew`
      ) {
        next(false);
      } else {
        next();
      }
    });
  },
};
</script>

<style lang="scss">
.main-app {
  min-height: 100vh;
}
.app-content {
  padding-bottom: 20px;
}

@media screen and (min-width: 1200px) {
  .main-column {
    max-width: calc(100% - 100px);
  }
}

@media screen and (min-width: 992px) {
  .app-content {
    min-height: 812px;
  }
}
</style>
